The pagination metadata for this page of webhook requests.
